import {
    paddingBottom,
    paddingHorizontal,
} from '@/features/pos/components/ProductCatalog/parts/CategoriesWithProducts/constants'
import React, { FC, ReactNode, RefObject } from 'react'
import { ScrollView, View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface WrapperProps {
    children: ReactNode
    horizontal?: boolean
    ref: RefObject<ScrollView | null>
    contentRef: RefObject<View | null>
    onScrollBeginDrag: () => void
}

const Wrapper: FC<WrapperProps> = ({
    children,
    horizontal,
    ref,
    contentRef,
    onScrollBeginDrag,
}) => {
    const { styles } = useStyles(stylesheet, { horizontal })

    return (
        <ScrollView
            horizontal={horizontal}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            onScrollBeginDrag={onScrollBeginDrag}
            style={styles.container}
            ref={ref}
        >
            <View collapsable={false} ref={contentRef} style={styles.contentContainer}>
                {children}
            </View>
        </ScrollView>
    )
}

const stylesheet = createStyleSheet((_, { insets }) => ({
    container: {
        flexGrow: 0,
    },
    contentContainer: {
        gap: 8,
        variants: {
            horizontal: {
                true: {
                    flexDirection: 'row',
                    paddingRight: paddingHorizontal,
                },
                false: {
                    width: 140,
                    paddingBottom: insets.bottom + paddingBottom,
                },
            },
        },
    },
}))

export default Wrapper
